import { URL_OFFICIAL_DOMAIN } from '@/globals/constants';
import { clearSession, setSession, setUserData } from '@/redux/slices/usession-supabase';
import { store } from '@/redux/store';
import { createBrowserClient } from '@supabase/ssr'

import { toast } from 'sonner';



import { createClient } from '@supabase/supabase-js';



export const createSupabaseAPIClient = () =>
    createClient(
        process.env.NEXT_PUBLIC_SUPABASE_URL!,
        process.env.SUPABASE_SECRET_KEY!,
        {
            db: {
                schema: 'majikah'
            }
        }
    );



export const createSupabaseBrowserClient = () =>
    createBrowserClient(
        process.env.NEXT_PUBLIC_SUPABASE_URL!,
        process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY!
    );





export const refreshSupabaseAccessToken = (): Promise<string | null> => {
    return new Promise<string | null>(async (resolve, reject) => {

        const supabase = createSupabaseBrowserClient();


        const sessionResponse = await supabase.auth.getSession();
        const userResponse = await supabase.auth.getUser();




        if (!!sessionResponse?.data && !!userResponse?.data) {

            const sessionData = sessionResponse.data.session;
            const userData = userResponse.data.user;

            store.dispatch(setSession(sessionData));
            store.dispatch(setUserData(userData));


            resolve(sessionData?.access_token as string);

        } else {
            console.log('No current user found. Session expired.');

            //Clear session and log out user
            toast('Your session has expired due to inactivity. Please log in again to continue using our services.', {
                action: {
                    label: 'Sign In',
                    onClick: () => window.location.href = `https://${URL_OFFICIAL_DOMAIN}/sign-in`
                },
            });
            store.dispatch(clearSession());
            window.location.href = `https://${URL_OFFICIAL_DOMAIN}/sign-in`
            console.log('Redirecting to Sign in.');

            reject("Session expired. Please log in again to continue.");
        }
    });
};

